import { render, staticRenderFns } from "./ingredient.vue?vue&type=template&id=7c62cec4&scoped=true"
import script from "./ingredient.vue?vue&type=script&lang=js"
export * from "./ingredient.vue?vue&type=script&lang=js"
import style0 from "./ingredient.vue?vue&type=style&index=0&id=7c62cec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c62cec4",
  null
  
)

export default component.exports